import OrionWebComponents from 'orion-web/components';
// @ts-ignore
import * as CustomerSVGIcons from 'orion-web/icons/customer';

// @ts-ignore
OrionWebComponents.SvgComponent = OrionWebComponents.SvgComponent(
  CustomerSVGIcons
);

export default OrionWebComponents;
